/**
 * 管理端 - 分栏菜单配置
 *
 * 布局模式：columns（分栏），与用户侧严格保持一致
 *   - 左侧 80px: 一级菜单（图标 + 短文字）
 *   - 右侧动态列: 二级菜单（文字列表，随一级选择切换）
 *   - 右侧主区: Header + 内容
 */

// 图标映射（使用 element-ui icon 名）
const ICONS = {
  dashboard: 's-home',
  ai: 'cpu',
  vendor: 's-cooperation',
  product: 's-goods',
  order: 's-order',
  bidding: 'data-line',
  finance: 's-finance',
  aftersale: 'warning',
  system: 'setting',
  logs: 'document',
}

/**
 * 菜单树结构
 * 每个一级菜单项: { path, title, icon, children[] }
 * 每个二级菜单项: { path, title }
 */
export const menuTree = [
  {
    path: '/dashboard',
    title: '工作台',
    icon: ICONS.dashboard,
    children: [{ path: '/dashboard', title: '首页概览' }],
  },
  {
    path: '/ai',
    title: 'AI辅助',
    icon: ICONS.ai,
    children: [
      { path: '/ai/decision', title: 'AI辅助决策' },
      { path: '/ai/analysis', title: 'AI辅助分析' },
    ],
  },
  {
    path: '/vendor',
    title: '供应商管理',
    icon: ICONS.vendor,
    children: [
      { path: '/vendor/list', title: '供应商列表' },
      { path: '/vendor/change-audit', title: '信息变更审批' },
      { path: '/vendor/qualification-audit', title: '资质审核' },
      { path: '/vendor/contract-manage', title: '合同管理' },
      { path: '/vendor/shutdown-audit', title: '关停审批' },
    ],
  },
  {
    path: '/product',
    title: '商品中心',
    icon: ICONS.product,
    children: [
      { path: '/product/center', title: '商品中心' },
      { path: '/product/audit', title: '商品审核' },
    ],
  },
  {
    path: '/order',
    title: '订单中心',
    icon: ICONS.order,
    children: [
      { path: '/order/monitor', title: '采购订单监控' },
      { path: '/order/report', title: '报备订单审核' },
      { path: '/order/reverse', title: '反采申请审核' },
      { path: '/order/ship', title: '发货单管理' },
    ],
  },
  {
    path: '/bidding',
    title: '竞价询价',
    icon: ICONS.bidding,
    children: [
      { path: '/bidding/purchase', title: '采购竞价管理' },
      { path: '/bidding/inquiry', title: '询价单管理' },
    ],
  },
  {
    path: '/finance',
    title: '财务结算',
    icon: ICONS.finance,
    children: [
      { path: '/finance/bill', title: '对账单管理' },
      { path: '/finance/invoice', title: '发票管理' },
    ],
  },
  {
    path: '/aftersale',
    title: '售后服务',
    icon: ICONS.aftersale,
    children: [{ path: '/aftersale/manage', title: '售后管理' }],
  },
  {
    path: '/system',
    title: '系统管理',
    icon: ICONS.system,
    children: [
      { path: '/system/role', title: '角色权限' },
      { path: '/system/menu', title: '菜单管理' },
      { path: '/system/message', title: '消息中心' },
    ],
  },
  {
    path: '/logs',
    title: '日志中心',
    icon: ICONS.logs,
    children: [{ path: '/logs', title: '操作日志' }],
  },
]

/** 扁平化所有叶子路径（用于 route path 白名单） */
export function flattenMenus(tree) {
  const result = []
  tree.forEach(item => {
    if (item.children && item.children.length > 0) {
      item.children.forEach(child => {
        result.push({ ...child, _parent: item.title })
      })
    } else {
      result.push(item)
    }
  })
  return result
}

/** 根据 path 找到所属的一级菜单 index（支持子路径前缀） */
export function findParentIndex(tree, path) {
  for (let i = 0; i < tree.length; i++) {
    const item = tree[i]
    if (item.path === path) return i
    if (path && path.startsWith(item.path + '/')) return i
    if (item.children) {
      const found = item.children.some(c => c.path === path || (path && path.startsWith(c.path + '/')))
      if (found) return i
    }
  }
  return 0
}

/** 根据一级菜单 index 获取子菜单列表 */
export function getChildrenByIndex(tree, index) {
  if (index >= 0 && index < tree.length) {
    return tree[index].children || []
  }
  return []
}

export default menuTree
